import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { UiSwitchModule } from 'ngx-ui-switch';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

import { PRIVILEGES_PROVIDERS, UtilsModule, BcDatePipe } from '@bayclubs/utils';
import { DropDownModule } from '@bayclubs/drop-down';

import { GcPermissionGuard, InfrastructureModule } from '../infrastructure/infrastructure.module';
import { ManagementContextResolverService, PrivilegesSnapshotResolverService, SharedModule } from '../shared/shared.module';

import { SubBoardPrivilegesProviderService } from './services/sub-board-privileges-provider-service.service';
import { SubstitutionRequestModelResolverService } from './services/substitution-request-model-resolver.service';

import { SubBoardComponent } from './components/sub-board/sub-board.component';
import { SubstitutionRequestListItemComponent } from './components/substitution-request-list-item/substitution-request-list-item.component';
import { SubBoardSectionHeaderComponent } from './components/sub-board-section-header/sub-board-section-header.component';
import { SubBoardRequestDetailsComponent } from './components/sub-board-request-details/sub-board-request-details.component';
import { SubstitutionRequestListItemBodyComponent } from './components/substitution-request-list-item-body/substitution-request-list-item-body.component';

import { ProposalListItemComponent } from './components/proposal-list-item/proposal-list-item.component';
import { BcValidators } from './services/bc-validators';
import { dualAuthGuard } from '../core/auth/dual-auth.guard';


export const subBoardRoutes: Routes = [
    {
        path: 'subboard',
        component: SubBoardComponent,
        canActivate: [dualAuthGuard, GcPermissionGuard],
        resolve: {
            context: ManagementContextResolverService,
            privilegesSnapshot: PrivilegesSnapshotResolverService
        },
        data: {
            expectedPermission: 'SubBoard.canViewSubstitutionRequests',
            title: 'NavBarMenu.SubstitutionBoardMenuItemLabel'
        }
    },
    {
        path: 'subboard/club/:clubId/request/:id',
        component: SubBoardRequestDetailsComponent,
        canActivate: [dualAuthGuard, GcPermissionGuard],
        resolve: {
            privilegesSnapshot: PrivilegesSnapshotResolverService,
            substitutionRequestModel: SubstitutionRequestModelResolverService
        },
        data: {
            expectedPermission: 'SubBoard.canViewSubstitutionRequests'
        }
    }
];

@NgModule({
    declarations: [
        SubBoardComponent,
        SubstitutionRequestListItemComponent,
        SubBoardSectionHeaderComponent,
        SubBoardRequestDetailsComponent,
        SubstitutionRequestListItemBodyComponent,
        ProposalListItemComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        UtilsModule,
        InfrastructureModule,
        UiSwitchModule,
        ReactiveFormsModule,
        TranslateModule.forChild(),
        RouterModule.forChild(subBoardRoutes),
        DropDownModule,
        NgxMaskDirective,
        NgxMaskPipe
    ],
    providers: [
        {
            provide: PRIVILEGES_PROVIDERS,
            useClass: SubBoardPrivilegesProviderService,
            multi: true
        },
        BcDatePipe,
        provideNgxMask()
    ]
})
export class SubBoardModule {}
